import React from "react";
import PropTypes from "prop-types";
import "./plans.m.css";

const plans = [
  {
    planId: "1_YEAR_ACCESS",
    year: "1 Year",
    label: " Print+Digital",
    term: "No of Issues 51",
    price: "4080",
    mainPrice: "5100",
    additionalBenefit: "Portronics Power Bank  ( Model: LUXCELL STRIDE 10) worth INR 1999",
  },
  {
    planId: "2_YEAR_ACCESS",
    year: "2 Year",
    label: " Print+Digital",
    term: "No of Issues 102",
    price: "7140",
    mainPrice: "10200",
    additionalBenefit: "Portronics Power Bank  ( Model: LUXCELL STRIDE 10) worth INR 1999",
  },
  {
    planId: "3_YEAR_ACCESS",
    year: "3 Year",
    label: " Print+Digital",
    term: "No of Issues 153",
    price: "9180",
    mainPrice: "15300",
    additionalBenefit: "Portronics Power Bank  ( Model: LUXCELL STRIDE 10) worth INR 1999",
  },
];

const bannerImageUrl =
  "https://media.openthemagazine.com/openthemagazine/2026-04-02/xe204b9h/open-subscribe-print-digital-banner.jpg";

const Plans = ({ selectedPlanId, onSelectPlan }) => {
  const handleSelectedplan = (planId) => {
    onSelectPlan(planId);

    // Scroll to details section
    const detailsSection = document.getElementById("details-section");
    if (detailsSection) {
      detailsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const calculateDiscount = (price, mainPrice) => {
    const discount = ((mainPrice - price) / mainPrice) * 100;
    return Math.round(discount);
  };

  return (
    <div styleName="wrapper">
      <div styleName="plans-grid">
        {plans.map((plan, index) => (
          <div
            styleName={`plan-card ${selectedPlanId === plan.planId ? "active-plan" : ""}`}
            key={index}
            onClick={() => handleSelectedplan(plan.planId)}
          >
            <div styleName="radio-button">
              <div styleName={`radio-circle ${selectedPlanId === plan.planId ? "selected" : ""}`}>
                {selectedPlanId === plan.planId && <div styleName="radio-dot"></div>}
              </div>
            </div>
            <div styleName="plan-content">
              <div styleName="plan-and-price">
                <div styleName="label">
                  <span>{plan.year}</span>
                  <span>{plan.label}</span>
                </div>
                <div styleName="price-wrapper">
                  <div styleName="price">₹{plan.price}</div>
                  <div styleName="mainprice">₹{plan.mainPrice}</div>
                  <div styleName="discount">-{calculateDiscount(plan.price, plan.mainPrice)}%</div>
                </div>
              </div>
              <div styleName="term">{plan.term}</div>
              {plan.additionalBenefit?.trim() ? (
                <div styleName="additional-benefit"><b>Additional Benefit:</b> {plan.additionalBenefit}</div>
              ) : null}
            </div>
            <div styleName="select">Select</div>
          </div>
        ))}
      </div>
      <div styleName="promo-section">
        <div styleName="banner-wrapper">
          <img
            src={bannerImageUrl}
            alt="Open Magazine Print and Digital subscription banner"
            styleName="banner-image"
          />
        </div>
      </div>
      <div styleName="contact-info">For any further details, please email us at <a href="mailto:customercare@openmedianetwork.in">customercare@openmedianetwork.in</a></div>
    </div>
  );
};

Plans.propTypes = {
  selectedPlanId: PropTypes.string,
  onSelectPlan: PropTypes.func,
};

export default Plans;
